import React, { useState } from "react";

// import JS files
import Navbar from "../shares/others/Navbar";
import Footer from "../shares/others/Footer";
import Breadcrumb from "../shares/others/Breadcrumb";
import MuiPagination from "../shares/mui/MuiPagination";
import PersonsCard from "../shares/others/PersonsCard";
import useFetch from "../../context/useFetch";

// import others files

const breadcrumbList = ["صفحه اصلی", "دیدگاه‌ها"];

const PersonsList = (props) => {


  const [newsList, setNewsList] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 12,
    count: 0,
  });
  const getSpecialListApi = useFetch({
    method: "get",
    url: "News_Service/get_face_news_page",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
       setPaginationPageInfo({
         current: res.current,
         pageSize: res.pageSize,
         count: res.count,
         next: res.next,
         previous: res.previous,
       });
    },
  });
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    //     setNewOerdersList({ results: [] });
        getSpecialListApi.reFetch();
  };
  return (
    <>
      <Navbar active_item="persons" />
      <div className="mx-8 2xl:mx-32 mt-8 mb-16">
        <Breadcrumb list={breadcrumbList} />

        <div className="my-4 grid md:grid-cols-4 gap-4">
          {newsList.results.map((it, ind) => {
            return [<PersonsCard data={it} showDate />];
          })}
        </div>
        <div className="flex justify-center mt-8">
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PersonsList;
